/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const PROFILE_PERMISSION_CONSTANTS = {
  REP_CUSTOMER: 'rep-customer',
  REP: 'rep',
  CUSTOMER: 'customer',
  SWITCH_ACCOUNTS: 'Switch Accounts',
  GLOBAL_IDENTIFIER: '.',
  GLOBAL_TARGET: '/global',
};
